import React, { useEffect, useState } from "react";
import "./ShowSongs.scss";
import { Link, useNavigate } from "react-router-dom";
import {
  IoCloseCircle,
  IoPencil,
  IoDesktopOutline,
  IoTrashOutline,
  IoShareSocialOutline
} from "react-icons/io5";
import moment from "moment";
import RestClient from "../../../@core/restClient";
import SongFullScreen from "../UI/SongFullScreen";
import { useDeprecatedAnimatedState, useScroll } from "framer-motion";

const ShowSongs = (props: any) => {
  const date = moment(props.date).format("DD.MM.YYYY");
  const [screenMode, setScreenMode] = useState(false);
  const parsedSongKeys: { songId: number; key: string }[] | null = (() => {
    if (!props.songKeys) return null;
    if (Array.isArray(props.songKeys)) return props.songKeys;
    try { return JSON.parse(props.songKeys); } catch { return null; }
  })();
  const getSongKey = (songId: number, originalKey: string) => {
    const entry = parsedSongKeys?.find((sk) => sk.songId === songId);
    return entry?.key || originalKey;
  };

  const closeFullScreen = () => {
    setScreenMode(false);
  };

  const shareSelection = () => {
    const url = `${window.location.origin}/songfullscreen?selectionId=${props.id}`;
    if (navigator.share) {
      navigator.share({ title: props.name, url });
    } else {
      navigator.clipboard.writeText(url);
    }
  };

  return (
    <div>
      <div className="show-slist">
        <div className="show-slist-title">
          <p className="show-slist-title-name">{props.name}</p>
          <p className="show-slist-title-date">{date}</p>
          <div className="show-slist-icons">
            <div className="my-tooltip">
              <IoDesktopOutline
                className="show-slist-icons-item"
                onClick={() => setScreenMode(true)}
              />
              <span className="my-tooltip-text tooltip-bottom-left">
                Відкрити добірку
              </span>
            </div>
            <div className="my-tooltip">
              <IoPencil
                className="show-slist-icons-item"
                onClick={() => {
                  props.editSelection(
                    props.id,
                    props.name,
                    props.date,
                    props.songs
                  );
                }}
              />
              <span className="my-tooltip-text tooltip-bottom-left">
                Редагувати добірку
              </span>
            </div>
            {props.isOwner && (
              <div className="my-tooltip">
                <IoShareSocialOutline
                  className="show-slist-icons-item"
                  onClick={shareSelection}
                />
                <span className="my-tooltip-text tooltip-bottom-left">
                  Поділитись
                </span>
              </div>
            )}
            <div className="my-tooltip">
              <IoTrashOutline
                className="show-slist-icons-item"
                onClick={() => props.onDelete(props.id)}
              />
              <span className="my-tooltip-text tooltip-bottom-left">
                Видалити добірку
              </span>
            </div>
          </div>
        </div>
        {props.songs.length !== undefined ? (
          <ol className="show-slist-list">
            {props.songs.map((el: any, i: any) => (
              <li className="show-slist-item" key={i}>
                <Link
                  className="show-slist-item-title"
                  to={`/songbook/${el?.songbookId}/song/${el?.id}`}
                >
                  {el?.title}
                </Link>
                <span>
                  {el?.time}-{el?.tempo}, {getSongKey(el?.id, el?.key)}
                </span>{" "}
              </li>
            ))}
          </ol>
        ) : (
          ""
        )}
      </div>
      {screenMode ? (
        <div>
          <SongFullScreen
            selectedSongs={props.songs}
            closeFullScreen={closeFullScreen}
            scroll={props.scroll}
            selectionId={props.id}
            songKeys={props.songKeys}
            onKeysUpdate={props.onKeysUpdate}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ShowSongs;
